import { memo } from 'react';
// import Control from './control';
import { Button } from '@headlessui/react';
import { MiniMap, useStoreApi } from '@xyflow/react';
import { useSyncDraft } from '../hooks/use-sync-draft';
import Control from './control';
import ZoomInOut from './zoom-in-out';
import { useWorkflowStore } from '../store';

const Operator = () => {
  const store = useStoreApi();
  const { resetDraft } = useSyncDraft();
  const workflowStore = useWorkflowStore();
  return (
    <>
      <MiniMap
        nodeColor={'#95a5a6'}
        style={{
          width: 102,
          height: 72,
        }}
        className="fill-gray-100 !w-[102px] !h-[72px] !absolute !left-4 !bottom-14 z-[9] !m-0 !border-[0.5px] !border-black/8 !rounded-lg !shadow-lg"
      />
      <div className="flex items-center mt-1 gap-2 absolute left-4 bottom-4 z-[9]">
        <ZoomInOut />
        {/* <Control /> */}
        {/* <Button
          className="rounded bg-sky-600 py-2 px-4 text-sm text-white data-[hover]:bg-sky-500 data-[hover]:data-[active]:bg-sky-700"
          onClick={async () => {
            // console.log(store.getState().nodes);
            // console.log(store.getState().edges);
            console.log(workflowStore.getState());

            // await resetDraft();
          }}
        >
          打印
        </Button> */}
        {/* <Button
          onClick={() => {
            const nodes = store.getState().nodes;
            console.log('设置。。。');

            nodes[0].measured.height = 100;
            nodes[0].data = {};
            const newNodes = nodes.map((node) => {
              node.measured.height = 100;
              return node;
            });
            store.setState({
              nodes: newNodes,
            });
          }}
        >
          debug
        </Button> */}
      </div>
    </>
  );
};

export default memo(Operator);
